import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { 
  persistStore, 
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import uploadHistorySlice, { cleanOldUploads } from './uploadHistorySlice';
import authSlice from './authSlice';

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: ['uploadHistory', 'auth']
};

const rootReducer = combineReducers({
  uploadHistory: uploadHistorySlice,
  auth: authSlice
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

export const persistor = persistStore(store, {}, () => {
  store.dispatch(cleanOldUploads());
  
  if (process.env.NODE_ENV === 'development') {
    const state = store.getState();
    console.log('Store initialized and old uploads cleaned:', {
      remainingUploads: state.uploadHistory.uploads.length,
      uploads: state.uploadHistory.uploads
    });
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;